namespace SorAraBul {
    export enum TenantStatus {
        formGonderildi = 0,
        raporHazirlaniyor = 1,
        raporHazirlandi = 2,
        kiralandi = 3
    }
    Serenity.Decorators.registerEnumType(TenantStatus, 'SorAraBul.TenantStatus');
}
